import React, { ChangeEvent, useLayoutEffect } from "react";
import { ReactComponent as LocationIcon } from "../../../assets/icons/location.svg";
import classNames from "classnames";
import Select from "../Select";
import { useGetRegionsListQuery } from "../../../store/regions/regions.api";
import s from "./index.module.scss";

interface Props {
  value?: string;
  onChange: (value: string) => void;
  className?: string;
}

const RegionSelect = ({ value, onChange, className }: Props) => {
  const { data } = useGetRegionsListQuery({});

  const options = data?.map((i) => ({ value: i.id, title: i.name }));

  useLayoutEffect(() => {
    if (!data?.length) return;

    onChange(data[0].id.toString());
  }, [data]);

  return (
    <div className={classNames(s.wrapper, className)}>
      <LocationIcon />
      <span>Регіон</span>
      {!!options?.length && (
        <Select
          value={value}
          onChange={(ev: ChangeEvent<HTMLSelectElement>) =>
            onChange(ev.target.value)
          }
          options={options}
          className={s.select}
        />
      )}
    </div>
  );
};

export default RegionSelect;
